import * as React from 'react';
import ReactDOM from 'react-dom';

import HeaderNotificationContainer from 'components/notification/header/pc/HeaderNotificationContainer';

const container = document.getElementById('header-notification');

if (container) {
  ReactDOM.render(<HeaderNotificationContainer />, container);
}
